<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="okService">

      <c-row>
        <c-col class="col-12 col-lg-4">
          <h1>{{ t('Alert Loops') }}</h1>
        </c-col>
        <c-col class="col-12 col-lg-8 text-end">
          <c-row>
            <c-col>
              <div class="btn-group mb-2 " role="group">
                <button class="btn btn-success text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" [disabled]="tooManyLoops">
                  <i class="fa-solid fa-plus"></i> {{ t('Create an Alert Loop') }}
                </button>
                <div class="btn-group">
                  <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import/Export') }}
                  </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" routerLink="/mgmt/alertloops/alertloops-upload"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Upload Alert Loops') }}</a></li>
                      <li><a class="dropdown-item"  (click)="export()"><i class="fa-solid fa-file-excel"></i> {{ t('Export Alert Loops') }}</a></li>
                    </ul>
                </div>
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35352962127377-Alert-Loops-Sequenced-Monitor-Alerts" role="button" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>
              </div>
              <br/>
            </c-col>
          </c-row>

        </c-col>
      </c-row>
      <c-row *ngIf="tooManyLoops" class="m-3">
        <br/>
        <c-col class="col-12 text-end">
          <span class="alert alert-danger">{{ t('The maximum number of Alert Loops is 3') }}</span>
        </c-col>
        <br/>
      </c-row>

      <ng-container *ngIf="!okService.settings.alertloop">
      <c-row>
        <c-col md="6">
          <p>
            {{ t('The Alert Loop is a series of steps that will be taken if an alert is triggered. Alerts that can trigger the Alert Loop to run include Help alerts, missed check ins, man/worker down alerts and high-risk check ins.') }}
          </p>
          <p>
            {{ t("Whichever Monitor accepts responsibility for resolving the alert can then follow either the company wide, group wide or individual’s own escalation procedure to make sure the worker is successfully contacted.") }}
          </p>
        </c-col>
        <c-col md="6">
          <div class="card mb-3">
            <div class="card-header">
              {{ t('Activate Out of Hours Alerts') }}
            </div>
            <div class="card-body">


              <ng-container *ngIf="!okService.billing.plan.comms_active">
                <div class="alert alert-warning" role="alert">
                  @if(okService.billing.plan.account_type == "Pricing2024"){
                    <i class="fa-solid fa-triangle-exclamation text-danger"></i>  {{ t('Alert Loops require the Automated Plan. To set up an automated plan please go to your') }}
                  }@else{
                    <i class="fa-solid fa-triangle-exclamation text-danger"></i>  {{ t('Alert Loops require the Comms Plan. To set up a comms plan please go to your') }}
                  }
                  <a routerLink="/account/account">{{ t('Account Settings') }}</a>.<br/>
                  
                  <i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about Alert Loops') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35908284843793-Upload-Export-Shift-Start-and-End-Times" target="_new">{{ t('here') }}</a>.
                </div>
                <button type="button" class="btn btn-primary btn-sm btn-success text-white" disabled="disabled">
                  {{ t('Activate Alert Loops') }}
                </button>
              </ng-container>
              <ng-container *ngIf="okService.billing.plan.comms_active">
                {{ t('Click here to activate Alert Loops on your account...') }}<br/>
                <button type="button" class="btn btn-primary btn-sm btn-success text-white" (click)="toggleEnabled()">
                 {{ t('Activate Alert Loops') }}
                </button>
              </ng-container>


            </div>
          </div>
        </c-col>
      </c-row>
      <c-row>
      <c-col>
        <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/qQC6w0_50nQ' frameborder='0' allowfullscreen></iframe></div>

      </c-col>
    </c-row>
      </ng-container>


      <ng-container *ngIf="okService.settings.alertloop">


        <c-row>
          <c-col class="col-12 my-1">
            <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('alertloop_info')">
              <i class="fa-solid fa-circle-info"></i> {{ t('The Alert Loop is a series of steps that will be taken if an alert is triggered. Alerts that can trigger the Alert Loop to run include Help alerts, missed check ins, worker down alerts and high-risk check ins.') }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('alertloop_info')"></button>
            </div>
          </c-col>
        </c-row>

          <div class="collapse" id="collapseExample">
            <div class="card mb-2">
              <div class="card-header">
                <h3>{{ t('Create a New Alert Loop') }}</h3>
              </div>
              <div class="card-body">

              <p>{{ t('Enter the name of the alert loop you wish to create.') }}</p>
              <form [formGroup]="nameFormGroup" cForm (ngSubmit)="submitForm()">
                <div class="form-group row mb-2 d-flex justify-content-start">
                  <div class="col-sm-8">
                    <input
                      [formControlName]="'name'"
                      cFormControl
                      placeholder="{{ t('Alert Loop Name') }}"
                      [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                    />
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['invalid']" class="invalid-feedback">
                      {{ f['name'].errors['invalid'] }}
                    </div>
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['required']" class="invalid-feedback">
                      {{ t('A valid name is required') }}
                    </div>
                  </div>
                </div>

                <button cButton class="btn btn-primary text-white" type="submit"><i class="fa-solid fa-check"></i> {{ t('Create Alert Loop Now') }}</button>

              </form>
            </div>
            </div>
          </div>


      <c-row>
        <c-col class="col-12 col-lg-6">



              <form cForm class="row row-cols-lg-auto g-2 mb-2 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
                <c-col class="col-sm-6">
                  <label cLabel class="visually-hidden" for="search">
                    {{ t('Search') }}
                  </label>
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                    <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                  </c-input-group>
                </c-col>

                <c-col xs="auto">
                  <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i>
                    <span class="d-none d-lg-inline">
                      {{ t('Search') }}
                    </span>
                  </button>
                  <button cButton class="btn btn-light text-danger" type="submit" (click)="cancelSearch()" *ngIf="formGroup.value.search" ><i class="fa-solid fa-circle-xmark"></i></button>
                </c-col>

                </form>

        </c-col>

        <c-col class="col-12 col-lg-6">

      <c-row class="justify-content-end">
        <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
          <c-input-group  class="text-end">
            <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
            <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
              <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
            </select>
          </c-input-group>
        </c-col>

        <c-col xs="auto" class="mb-2">
            <div class="btn-group btn-group-md" role="group" aria-label="Basic example">
  
  
              <button class="btn btn-secondary d-none d-lg-inline" disabled>{{ t('View') }}</button>
  
              <button type="button" class="btn " [class.btn-outline-secondary]="view!='full'" [class.btn-info]="view=='full'" (click)="changeView('full')">
                <i class="fa-solid fa-table-cells-large"></i> {{ t('Full') }}
              </button>
              <button type="button" class="btn " [class.btn-outline-secondary]="view!='row'" [class.btn-info]="view=='row'" (click)="changeView('row')">
                <i class="fa-solid fa-table-list"></i> {{ t('Row') }}
              </button>
            </div>
          </c-col>

        <c-col xs="auto" class="mb-2">
          <c-input-group>
            <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
            <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
              <option value="newest">{{ t('Newest') }}</option>
              <option value="oldest">{{ t('Oldest') }}</option>
              <option value="name">{{ t('Name') }}</option>
            </select>
          </c-input-group>
        </c-col>
      </c-row>
    </c-col>
  </c-row>

  <ng-container *ngIf="alertloops && view=='row'">

    

    <table
    [hover]="true"
    [responsive]="true"
    [striped]="true"
    align="middle"
    cTable
    class="mb-0 border"
    >
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">{{ t('Name') }}</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alertloop of alertloops">
            <td>
              <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/alertloop/{{alertloop.id}}">
                <svg cIcon class="me-2" name="cil-pencil"></svg>
                {{ t('Edit') }}
              </button>
            </td>
            <td>
              <h3>
                <b>{{alertloop.name}}</b>
              </h3>
            </td>

          </tr>
        </tbody>

    </table>


  </ng-container>


      <ng-container *ngIf="alertloops && view=='full'">
        <c-row>

          <c-col *ngFor="let alertloop of alertloops" class="col-12 col-lg-6">
            <c-card class="mb-1">
              <c-card-header>
                <c-row>
                  <c-col>
                    <h3>
                      <b>{{alertloop.name}}</b>
                    </h3>
                  </c-col>
                  <c-col>
                    <div class=" col d-flex justify-content-end">
                      <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/alertloop/{{alertloop.id}}">
                        <svg cIcon class="me-2" name="cil-pencil"></svg>
                        {{ t('Edit') }}
                      </button>
                    </div>
                  </c-col>
                </c-row>
              </c-card-header>
              <c-card-body>
                <c-row>
                  <c-col>
                    <b>
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                      {{ t('Loop Count:') }} {{alertloop.loop_count}} {{ t('loops') }}
                    </b>
                  </c-col>
                  <c-col>
                    <b>
                      <i class="fa fa-hourglass" aria-hidden="true"></i>
                      {{ t('Loop Wait:') }} {{alertloop.loop_wait}} {{ t('mins') }}
                    </b>
                  </c-col>
                </c-row>
                <c-row>
                  <ul class="list-group p-2">
                    <ng-container *ngFor="let step of alertloop.steps; let i = index">

                      <li class="list-group-item list-group-item-light">
                        <span><h5>{{ t('Contact') }} {{step.name}} {{ t('by') }} {{step.contact}}</h5></span>
                        <span *ngIf="step.use_email"><i class="fa-solid fa-envelope"></i> {{step.email}}<br /></span>
                        <span *ngIf="step.use_phone"><i class="fa-solid fa-phone"></i> {{step.phone}}<br /></span>
                        <span *ngIf="step.use_sms"><i class="fa-solid fa-comment-sms"></i> {{step.cell}}<br /></span>
                        <span *ngIf="step.use_whatsapp"><i class="fa-brands fa-whatsapp"></i> {{step.cell}}<br /></span>
                      </li>

                      <li class="list-group-item list-group-item-info" *ngIf="i != alertloop.steps.length-1">
                        <i class="fa fa-hourglass" aria-hidden="true"></i>
                        {{ t('Wait') }} {{step.wait}} {{ t('minutes.') }}<br />
                      </li>

                    </ng-container>

                    <li class="list-group-item list-group-item-success">
                      <i class="fa fa-hourglass" aria-hidden="true"></i>
                      {{ t('Wait') }} {{alertloop.loop_wait}} {{ t('minutes between loops.') }}<br />
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                      {{ t('Run the Loop') }} {{alertloop.loop_count}} {{ t('time(s)') }}<br />
                    </li>

                  </ul>
                </c-row>
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </ng-container>

      </ng-container>
  </c-card-body>
</c-card>
